import { Link } from '@inertiajs/react'
import PublicLayout from '../layouts/PublicLayout'
import Monogram from '../components/Monogram'
import usePoll from '../hooks/usePoll'
import { isPlayed as played, hasPenalties, penaltiesLabel, homeWins, awayWins } from '../lib/result'

// Wraps a knockout card in a link to its match page when a game number exists.
function MatchLink({ slug, match, className, children }) {
  if (!match || match.gameNumber == null) return <div className={className}>{children}</div>
  return (
    <Link href={`/${slug}/jogo/${match.gameNumber}`} className={className}>
      {children}
    </Link>
  )
}

function MatchRow({ team, label, score, pens, win }) {
  return (
    <div className={`mrow ${win ? 'w' : ''}`}>
      {team ? <Monogram team={team} size={22} /> : null}
      {win ? <b>{team ? team.shortName : label}</b> : team ? team.shortName : label}
      <span className="s">
        {score == null ? '—' : score}
        {pens != null && <small className="pens"> ({pens})</small>}
      </span>
    </div>
  )
}

function MatchCard({ match, slug, className = '', tag }) {
  if (!match) return null
  return (
    <MatchLink slug={slug} match={match} className={`match ${className}`}>
      {tag && <div className="ttag">{tag}</div>}
      <MatchRow
        team={match.home}
        label={tag ? 'A definir' : match.label}
        score={played(match) ? match.homeScore : null}
        pens={hasPenalties(match) ? match.homePenalties : null}
        win={homeWins(match)}
      />
      <MatchRow
        team={match.away}
        label=""
        score={played(match) ? match.awayScore : null}
        pens={hasPenalties(match) ? match.awayPenalties : null}
        win={awayWins(match)}
      />
    </MatchLink>
  )
}

function PlacementCard({ title, match, slug, posLabel }) {
  if (!match) return null
  const hasTeams = match.home && match.away
  const pens = penaltiesLabel(match)
  return (
    <MatchLink slug={slug} match={match} className="placement">
      <h4>{title}</h4>
      <div className="pl">
        {posLabel && <span className="pos">{posLabel}</span>}
        {hasTeams ? (
          <>
            <Monogram team={match.home} size={22} />
            {match.home.shortName}
            <b style={{ margin: '0 6px', color: homeWins(match) ? 'var(--pitch)' : undefined }}>
              {played(match) ? match.homeScore : '–'}
            </b>
            –
            <b style={{ margin: '0 6px', color: awayWins(match) ? 'var(--pitch)' : undefined }}>
              {played(match) ? match.awayScore : '–'}
            </b>
            {match.away.shortName}
            <Monogram team={match.away} size={22} />
            {pens && <span className="pens">{pens}</span>}
          </>
        ) : (
          <span>{match.label}</span>
        )}
      </div>
    </MatchLink>
  )
}

export default function Knockout({ currentEdition, editions, stages = {} }) {
  usePoll(15000)
  const slug = currentEdition.slug
  const semis = stages.semifinal || []
  const final = (stages.final || [])[0]
  const third = (stages.third_place || [])[0]
  const fifth = (stages.fifth_place || [])[0]
  const seventh = (stages.seventh_place || [])[0]
  const ninth = (stages.ninth_place || [])[0]

  return (
    <PublicLayout currentEdition={currentEdition} editions={editions} active="eliminatorias">
      <div className="sechead">
        <h3>Quadro Final</h3>
        <div className="rule"></div>
        <span className="note">tarde · 14h–17h</span>
      </div>

      <div className="bracket">
        <div className="bcol">
          <div className="lab">Meias-finais</div>
          {semis.map((m) => (
            <MatchCard key={m.id} match={m} slug={slug} />
          ))}
        </div>

        <div className="bcol">
          <div className="lab">Final · {final ? final.time : '17:00'}</div>
          {final && (
            <MatchLink slug={slug} match={final} className="match final">
              <div className="ftag">🏆 Final</div>
              <MatchRow
                team={final.home}
                label="A definir"
                score={played(final) ? final.homeScore : null}
                pens={hasPenalties(final) ? final.homePenalties : null}
                win={homeWins(final)}
              />
              <MatchRow
                team={final.away}
                label="A definir"
                score={played(final) ? final.awayScore : null}
                pens={hasPenalties(final) ? final.awayPenalties : null}
                win={awayWins(final)}
              />
            </MatchLink>
          )}
          <div style={{ marginTop: 6 }}>
            <MatchCard match={third} slug={slug} className="third" tag="3º / 4º lugar" />
          </div>
        </div>

        <div className="bcol">
          <div className="lab">Lugares 5º – 10º</div>
          <PlacementCard title="5º / 6º" match={fifth} slug={slug} posLabel="5º" />
          <PlacementCard title="7º / 8º" match={seventh} slug={slug} posLabel="7º" />
          <PlacementCard title="9º / 10º" match={ninth} slug={slug} posLabel="9º" />
        </div>
      </div>
    </PublicLayout>
  )
}
